export enum TabsEnum {
  firstTab = 0,
  secondTab = 1,
}
